import { notification } from "antd";

export const applyNotificationConfig = () =>
  notification.config({
    placement: "bottomRight",
  });
